<template>
	<div class="techonlogy">
		<div class="techonlogy-top">
			<img src="../../static/img/fuwu.jpg"/>
		</div>
		<div class="tech-detail">
			<div class="tech-top-top">
				<h4>{{tech[0].title}}</h4>
				<div class="tech-line">	
				</div>
			</div>
			<div class="techinfo" v-html="news[0].Contentall">
					{{news[0].Contentall}}
            </div>
            <!--业务模式-->
		</div>
	</div>
</template>

<script>
	export default{
		name : 'techonlogy',
		data () {
			return {
				tech : [
				{id : 0 , imgsrc : 'static/img/fuwu.jpg' , title : '企业形象' },
				],
				techimg : [
				{id : 0 , smalltit : '组织框架图'},
				{id : 1 , smalltit : '资质荣誉'},
				],
				honor :[
				{id : 0 , hoimg : 'static/img/zz1.jpg', honame : '■ 安全生产许可证'},
				{id : 1 , hoimg : 'static/img/zz4.jpg', honame : '■ 承装电力设施许可证'},
				{id : 2 , hoimg : 'static/img/zz5.jpg', honame : '■ 广东能源协会会员单位证'},
				{id : 3 , hoimg : 'static/img/zz6.jpg', honame : '■ 守合同重信用证书2008-2016'},
				{id : 4 , hoimg : 'static/img/zz7.jpg', honame : '■ 施工总承包三级'},
				{id : 5 , hoimg : 'static/img/zz8.jpg', honame : '■ ISO质量管理体系认证证书'},
				{id : 6 , hoimg : 'static/img/zz9.jpg', honame : '■ ISO职业健康安全管理体系认证证书'},
				{id : 7 , hoimg : 'static/img/zz10.jpg', honame : '■ ISO环境管理体系认证证书'}
				],
				honorname :[
				{id : 0 , honame : '■ 计算机信息系统集成企业资质证书叁级'},
				{id : 1 , honame : '■ 广东省公共安全技术防范系统设计、施工、维修资格证（壹级）证书'},
				{id : 2 , honame : '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书'},
				{id : 3 , honame : '■ 软件企业认定证书'},
				{id : 4 , honame : '■ ISO9001 2015质量管理体系认证证书'},
				{id : 5 , honame : '■ 高新技术企业证书'},
				{id : 6 , honame : '■ 音视频工程业企业资质贰级'},
				{id : 7 , honame : '■ 守合同重信用企业（连续九年）'}
				],
				news:[],
			}
		},
		mounted(){
			this.getnews();
		},
		methods : {
			getnews(){
	      			var that = this;
	      			var conlist = [];
	     				this.$http.post('http://www.gd-sc.net:9094',{table : 'contentall'},{emulateJSON: true}).then((response) => {
				        for(var i=0 ; i<response.body.recordset.length ; i++){
				        	if(response.body.recordset[i].Alltype == '企业形象'){
				        		conlist.push(response.body.recordset[i])
				        	}
				        }
				        that.news = conlist;
				        console.log(conlist)
				      })
	     			},
			},
	}
</script>

<style>
	.techonlogy{
		width: 100%;
		position: relative;
		clear: both;
		overflow: hidden;
	}
	.tech-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;		
	}
	.tech-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #e01313;
		border-radius: 4px;
		top: 8px;
	}	
	.techonlogy-top img{
		width: 100%;
	}
	.tech-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
	}
			.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.tech-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}	
	.techinfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
	.techinfo p{
		color: #666666;
		line-height: 35px;
		font-size: 16px;
	}
	.techinfo img{
		text-align: center;
	}
	.tech-singleimg{
		text-align: center;
		position: relative;
	}
	.tech-singleimg img{
		margin-top: 40px;
	
	}
	.tech-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 20px auto 0;
		position: relative;
		color: #e01313 ;
		font-weight: 500;
	}
	.honor{
		position: relative;
		width: 20%;
		clear: both;
		display: inline-block;
		text-align: center;
		margin-right: 20px;
		margin-left: 20px;
		margin-bottom: 30px;
		vertical-align: top;
	}
	.honor img{
		width: 100%;
   		margin-bottom: 30px;
	}
	.honor img:hover{
		transform: scale(1.1);
	}
</style>


// WEBPACK FOOTER //
// src/components/culture.vue